<template>
  <div class="unsubscribe-page" v-loading.fullscreen.lock="loading">
    <main-image-section
      img="https://tuango-contest-assets.s3.amazonaws.com/homepage/estrie.jpg"
    ></main-image-section>
    <div class="container" :class="[!isUsubscribed ? 'blur' : 'unblur']">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h1 class="fnt font-default-light">
              {{ $t("UNSUBSCRIBE__TITLE") }}
            </h1>
            <p v-html="$t('UNSUBSCRIBE__MSG')"></p>
            <div class="content-narrow" v-if="contestUserToken">
              <div class="block">
                <p v-html="$t('UNSUBSCRIBE__MSG_2')"></p>
                <el-button @click="gotoMyPlane" type="primary" class="w100">
                  {{ $t("SHARE_PAGE__MY_PLANE_BTN") }}
                  <i class="fas fa-car-side"></i>
                </el-button>
              </div>
              <h6
                class="fnt font-deco block m-t-b"
                v-html="$t('UNSUBSCRIBE__GOOD_LUCK')"
              ></h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('UNSUBSCRIBE__UNSUB_POPUP_TITLE')"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      width="340px"
    >
      <span v-html="$t('UNSUBSCRIBE__UNSUB_POPUP_TXT')"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{ $t("SHARED__CANCEL") }}</el-button>
        <el-button type="primary" @click="unsubscribe">{{
          $t("SHARED__CONFIRM")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import to from "await-to-js"

import MainImageSection from "../components/Layout/MainImageSection"
import UserService from "../services/api/UserService"

const userService = new UserService()

export default {
  name: "Unsubscribe",
  components: {
    MainImageSection
  },
  data() {
    return {
      dialogVisible: false,
      invitedUserToken: null,
      contestUserToken: null,
      loading: false,
      user: {},
      isUsubscribed: false
    }
  },
  methods: {
    async handleContestUser(token, userId) {
      let err, user
      ;[err, user] = await to(userService.get(userId, token))

      if (err) {
        this.$router.push({ name: "error" })
      }

      this.contestUserToken = token
      this.user = user
    },
    async unsubscribe() {
      let err
      ;[err] = await to(
        userService.unsubscribe({
          token: this.invitedUserToken || this.contestUserToken,
          isContestUser: !!this.contestUserToken
        })
      )

      if (err) {
        this.$router.push({ name: "error" })
      }

      this.dialogVisible = false
      this.isUsubscribed = true
    },
    cancel() {
      this.$router.push({ name: "home" })
    },
    gotoMyPlane() {
      this.$router.push({
        name: "status",
        query: { t: this.contestUserToken, u: this.user.id }
      })
    }
  },
  async created() {
    this.loading = true

    // If query param e is present: invited user
    if (this.$route.query.e) {
      this.invitedUserToken = this.$route.query.e
    } else if (this.$route.query.t && this.$route.query.u) {
      // If query params u and t are present: contest user
      await this.handleContestUser(this.$route.query.t, this.$route.query.u)
    } else {
      this.$router.push({ name: "error" })
    }

    this.loading = false

    this.dialogVisible = true
  }
}
</script>
